import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
`;

const MainLayoutWrapper = ({ children }) => {
    return (
        <Container>
            {children}
        </Container>
    )
}

export default MainLayoutWrapper